function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.3333 14.6666H2.66666V13.3333C2.66666 12.4492 3.01785 11.6014 3.64297 10.9763C4.26809 10.3511 5.11593 9.99996 5.99999 9.99996H9.99999C10.884 9.99996 11.7319 10.3511 12.357 10.9763C12.9821 11.6014 13.3333 12.4492 13.3333 13.3333V14.6666ZM7.99999 8.66663C7.4747 8.66663 6.95456 8.56316 6.46926 8.36214C5.98395 8.16113 5.543 7.86649 5.17156 7.49505C4.80013 7.12362 4.50549 6.68266 4.30447 6.19736C4.10345 5.71206 3.99999 5.19191 3.99999 4.66663C3.99999 4.14134 4.10345 3.62119 4.30447 3.13589C4.50549 2.65059 4.80013 2.20963 5.17156 1.8382C5.543 1.46676 5.98395 1.17213 6.46926 0.971108C6.95456 0.770089 7.4747 0.666626 7.99999 0.666626C9.06086 0.666626 10.0783 1.08805 10.8284 1.8382C11.5786 2.58834 12 3.60576 12 4.66663C12 5.72749 11.5786 6.74491 10.8284 7.49505C10.0783 8.2452 9.06086 8.66663 7.99999 8.66663Z",
  fill: "#333333"
});

var SvgUserFill = function SvgUserFill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUserFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user-fill.ef50fa25.svg";
export { ForwardRef as ReactComponent };